<ng-container [ngSwitch]="editMode$ | async">
  <app-add-document-items
    *ngSwitchCase="true"
    class="editor"
    [documentItem]="documentItem"
    [document]="document"
    [documentDataBuilder]="documentDataBuilder"
    [documentTaxes]="documentTaxes"
    [documentWithholdingTax]="documentWithholdingTax"
    [documentSettings]="documentSettings"
    [enableDiscount]="enableDiscount"
    [trackingObject]="trackingObject"
    [trackingScreenName]="trackingScreenName"
    [companySettings]="companySettings"
    (deleteDocumentItem)="onDeleteDocumentItem.emit(documentItem)"
    (saveDocumentItem)="onSave($event)"
    (close)="onClose()"
    (saveItemToList)="onSaveItemToList.emit($event)"
  >
  </app-add-document-items>

  <div
    *ngSwitchDefault
    class="document-items-list-item"
    data-e2e-id="document-items-list-item"
    (click)="onClick($event)"
  >
    <app-icon
      class="reorder-icon"
      [ngClass]="sortableHandle"
      [icon]="reorderIcon"
    ></app-icon>

    <div class="item-content">
      <h3 *ngIf="itemTitle" class="item-title">
        <span [multiLineTruncate]="3">
          {{ itemTitle }}
        </span>
      </h3>

      <p
        *ngIf="documentItem?.description as description"
        class="description"
        [multiLineTruncate]="itemTitle ? 2 : 3"
      >
        {{ description }}
      </p>

      <div class="meta">
        <div class="left-contents item-total-breakdown">
          {{ itemTotalBreakdown }}
        </div>

        <div class="right-contents total">
          {{
            documentItemCalculationResult?.subTotal
              | money: documentSettings?.currencyCode:documentSettings?.locale
          }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
